import { createFileRoute } from '@tanstack/react-router'
import { FormWizard } from '../../../../components/FormWizard'

export const Route = createFileRoute('/desa/$slug/form/$kode')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: FormWizardPage,
})

function FormWizardPage() {
  const { slug, kode } = Route.useParams()
  const { token } = Route.useSearch()
  return <FormWizard slug={slug} kode={kode} token={token} />
}
